import React, { useState } from "react";
import {
   useGlobalFilter,
   usePagination,
   useSortBy,
   useTable,
} from "react-table";
import Pagination from "@atlaskit/pagination";
import Datepicker from "./Datepicker";

function Table({
   title,
   columns,
   data,
   isLoading,
   pageSelected,
   setPageSelected,
   pages,
   properties,
   enDatepicker,
   enSearch,
   enDownload,
   date,
   setDate,
   setSearch,
   setChangeKey,
   setShowModal,
}) {
   const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      page,
      prepareRow,
      state,
      gotoPage,
      pageCount,
   } = useTable(
      {
         columns,
         data,
      },
      useGlobalFilter,
      useSortBy,
      usePagination
   );
   const { globalFilter } = state;
   const [maxPageSize, setMaxPageSize] = useState(7);
   const [searchData, setSearchData] = useState("");
   const handleEllipsisCLick = () => setMaxPageSize(10);
   const handleChange = (event, newPage) => {
      // if (pages) {
      //   if (properties) {
      //     setChangeKey(properties);
      //     setPageSelected((prevState) => ({
      //       ...prevState,
      //       [properties]: newPage,
      //     }));
      //   } else {
      //     setPageSelected((prevState) => ({
      //       ...prevState,
      //       pageSelected: newPage,
      //     }));
      //   }
      // } else {
      // }
      if (data.length <= 10) {
         setPageSelected(newPage);
      }
      gotoPage(newPage - 1);
      // setPageSelected(newPage);
   };

   return (
      <div className="col-span-full bg-white rounded-sm border border-gray-200">
         <header className="flex flex-col px-5 py-4 border-b border-gray-100">
            <div className="pb-2 flex flex-row border-b justify-between items-center">
               <h2 className="font-semibold text-gray-700 ">{title}</h2>
               {enDownload ? (
                  isLoading ? (
                     <div className="animate-pulse w-36 h-6 mb-2 rounded-md bg-gray-200"></div>
                  ) : (
                     <button
                        className="btn bg-green-600 hover:bg-green-700 text-white"
                        onClick={(e) => {
                           e.stopPropagation();
                           setShowModal(true);
                           setChangeKey(properties);
                        }}
                     >
                        Export Excel
                     </button>
                  )
               ) : (
                  <></>
               )}
            </div>

            <div
               id="dt-responsive_length"
               className="flex justify-between items-center mt-4"
            >
               {/* Fitur Search */}
               {enSearch && (
                  <div className="flex">
                     <div className="relative">
                        <input
                           id="form-search"
                           className="form-input w-full pl-4 "
                           type="search"
                           placeholder="Search"
                           aria-controls="dt-responsive"
                           value={searchData}
                           onChange={(e) => {
                              setSearchData(e.target.value);
                           }}
                        />
                     </div>
                     <button
                        className={`ml-2 inline-flex items-center justify-center text-sm font-sm leading-5 rounded-md px-3 py-1 border border-transparent shadow-sm ${"bg-blue-dark text-white"} duration-150 ease-in-out`}
                        onClick={() => {
                           setChangeKey(properties);
                           setSearch((prevState) => ({
                              ...prevState,
                              [properties]: searchData,
                           }));
                        }}
                     >
                        <svg
                           className="w-4 h-4 flex-shrink-0 fill-current text-white-400 group-hover:text-gray-500 "
                           viewBox="0 0 16 16"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
                           <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
                        </svg>
                     </button>
                  </div>
               )}
               {/* Fitur Datepicker */}
               {enDatepicker && (
                  <Datepicker
                     align="right"
                     setDate={setDate}
                     date={date}
                     size="w-full"
                  />
               )}
            </div>
         </header>
         <div className="p-3">
            {isLoading ? (
               <>
                  <div className="flex items-center justify-center w-full h-72">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="animate-pulse h-24 w-24 text-gray-300"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                     >
                        <path
                           stroke-linecap="round"
                           stroke-linejoin="round"
                           stroke-width="2"
                           d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                        />
                     </svg>
                  </div>
               </>
            ) : (
               <>
                  {/* Table */}
                  <div className="overflow-x-auto">
                     <table className="table-auto w-full" {...getTableProps()}>
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                           {headerGroups.map((headerGroup) => (
                              <tr {...headerGroup.getHeaderGroupProps()}>
                                 {headerGroup.headers.map((column) => (
                                    <th
                                       className="p-2 whitespace-nowrap "
                                       {...column.getHeaderProps(
                                          column.getSortByToggleProps()
                                       )}
                                    >
                                       {column.render("Header")}
                                       <span>
                                          {column.isSorted
                                             ? column.isSortedDesc
                                                ? " 🔽"
                                                : " 🔼"
                                             : ""}
                                       </span>
                                    </th>
                                 ))}
                              </tr>
                           ))}
                        </thead>
                        {/* Apply the table body props */}
                        <tbody
                           className="text-sm divide-y divide-gray-200"
                           {...getTableBodyProps()}
                        >
                           {page.map((row) => {
                              prepareRow(row);
                              return (
                                 <tr {...row.getRowProps()}>
                                    {row.cells.map((cell) => {
                                       return (
                                          <td
                                             className="p-2 whitespace-nowrap"
                                             {...cell.getCellProps()}
                                          >
                                             {cell.render("Cell")}
                                          </td>
                                       );
                                    })}
                                 </tr>
                              );
                           })}
                        </tbody>
                     </table>
                  </div>
                  <div className="flex justify-center mt-4">
                     <Pagination
                        onChange={handleChange}
                        defaultSelectedIndex={pageSelected}
                        pages={
                           pages
                              ? pages.map((_, i) => i + 1)
                              : [...Array(pageCount)].map((_, i) => i + 1)
                        }
                     />
                  </div>
               </>
            )}
         </div>
      </div>
   );
}

export default Table;
